import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { client } from '../api/Api';
import { Box, Paper, Typography, TextField, Grid, Button, CircularProgress, Alert } from '@mui/material';

const PriceAdminEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [price, setPrice] = useState({ value: '', date: '', productName: '', providerName: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await client.get(`/admin/prices/${id}`);
        // date is LocalDate (YYYY-MM-DD), can be used directly in date input
        setPrice({
          value: res.data.value != null ? res.data.value : '',
          date: res.data.date || '',
          productName: res.data.productName || '',
          providerName: res.data.providerName || ''
        });
      } catch (e) {
        setError('Nepavyko užkrauti kainos duomenų');
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrice((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const payload = {
        value: price.value === '' ? null : Number(price.value),
        date: price.date || null
      };
      await client.put(`/admin/prices/${id}`, payload);
      setSuccess('Išsaugota sėkmingai');
      setTimeout(() => navigate('/admin/prices'), 800);
    } catch (e) {
      setError('Nepavyko išsaugoti kainos');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Redaguoti kainą</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <Paper sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">Produktas</Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>{price.productName || '-'}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">Tiekėjas</Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>{price.providerName || '-'}</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Kaina" name="value" value={price.value} onChange={handleChange} type="number" fullWidth inputProps={{ step: '0.01' }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField label="Data" name="date" value={price.date} onChange={handleChange} type="date" fullWidth InputLabelProps={{ shrink: true }} />
          </Grid>
        </Grid>
        <Box display="flex" gap={2} mt={3}>
          <Button variant="outlined" onClick={() => navigate('/admin/prices')}>Atgal</Button>
          <Button variant="contained" onClick={handleSave} disabled={saving}>{saving ? 'Saugoma...' : 'Išsaugoti'}</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default PriceAdminEdit;
